import { __assign } from "tslib";
import { MatrixUtils } from '../../math';
import { BlendMode } from '../../property/fill/types';
export var createItemProps = function (partial) {
    if (partial === void 0) { partial = {}; }
    return __assign({ applyMatrix: false, assets: [], blendMode: BlendMode.Normal, blur: 0, data: {}, flipX: false, flipY: false, isExportable: false, locked: false, matrix: MatrixUtils.create(), name: '', opacity: 1 }, partial);
};
